import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowLeftOutlined } from '@ant-design/icons';

type BackButtonProps = {
	// Provide a specific URL to return to or it will assume backwards
	backUrl?: string,
	// Optionally override the back text
	text?: string
}

const BackButton: React.FC<BackButtonProps> = ({
	backUrl = null,
	text = null
}) => {

	const navigate = useNavigate();
	const backLabel = text ?? "Back";
	const hasUrl = backUrl != null;

	const handleBackClick = () => {
		if (hasUrl) {
			navigate(backUrl);
		} else {
			// Check if there's any history to go back to
			if (window.history.length > 1) {
				navigate(-1);
			} else {
				// No history available, navigate to view-candidates page
				navigate('/view-candidates');
			}
		}
	};

	return (
		<>
			<div style={{ marginBottom: '16px' }}>
				<Button
					type="text"
					icon={<ArrowLeftOutlined />}
					onClick={handleBackClick}
					style={{ color: '#666' }}
				>
					{backLabel}
				</Button>
			</div>
		</>
	);
};

export default BackButton;